import React, { useState } from 'react';
import { Avatar, Flex, Popover, Typography } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import './style.scss';
import testId from 'utils/testId';

const { Text } = Typography;

const UserProfile = ({
  renderPopoverContent,
  userName,
  userRole,
  trigger = 'hover',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      trigger={trigger}
      content={renderPopoverContent}
      open={isOpen}
      onOpenChange={setIsOpen}
      role="menu"
      aria-label="User Profile Menu"
      data-testid={testId?.navbar?.['slc-navbar-user_profile']}
    >
      <Flex
        align="center"
        gap={8}
        role="button"
        tabIndex={0}
        aria-label="User Profile Button"
        className="user-profile-container"
      >
        <Avatar
          icon={<UserOutlined />}
          className="user-profile-avatar"
          data-testid={testId?.navbar?.['img-navbar-user_avatar']}
        />
        <Flex vertical className="overflow-hidden">
          <Text
            className="user-profile-name"
            ellipsis
            aria-label="User Name"
            data-testid={testId?.navbar['text-navbar-username']}
          >
            {userName}
          </Text>
          <Text
            type="secondary"
            className="user-profile-role"
            ellipsis
            aria-label="User Role"
            data-testid={testId?.navbar?.['text-navbar-user_role']}
          >
            {userRole}
          </Text>
        </Flex>
        <DownOutlined
          className="user-profile-dropdown-icon"
          data-open={isOpen}
          aria-hidden="true"
        />
      </Flex>
    </Popover>
  );
};
export default UserProfile;
